import { render } from "./ConversationView.vue?vue&type=template&id=a1bdd3c8&scoped=true"
import script from "./ConversationView.vue?vue&type=script&lang=js"
export * from "./ConversationView.vue?vue&type=script&lang=js"

import "./ConversationView.vue?vue&type=style&index=0&id=a1bdd3c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1bdd3c8"]])

export default __exports__